import { CostPriceUploadBody, ServiceIdentifier, TourService } from '~/types/tours/costPrice';

import { json_headers, request } from './common';

interface OkResponse<T> {
  status: number;
  message: string | null;
  result: T;
}

function basePath(): string {
  return `${window.configs.API_HOST}/api/v2/tours`;
}

/**
 * svc-tour keys tour endpoints by a bare uuid, while Admin routes carry the
 * prefixed `tour-<uuid>` identifier.
 */
function stripTourPrefix(tourId: string): string {
  return tourId.replace(/^tour-/, '');
}

/**
 * Lists the supplier services on a tour. Cost prices hang off a service, so
 * this is how the supplier and service ids are resolved for a given tour.
 */
export async function getTourServices(tourId: string, options?: { signal?: AbortSignal }): Promise<Array<TourService>> {
  const response: OkResponse<Array<TourService>> = await request(`${basePath()}/${stripTourPrefix(tourId)}/services`, {
    method: 'GET',
    signal: options?.signal,
  });

  return response.result;
}

function costPricesPath({ supplierId, serviceId }: ServiceIdentifier): string {
  return `${basePath()}/suppliers/${supplierId}/services/${serviceId}/cost-prices`;
}

/**
 * Returns a service's SlidingScale cost prices in the same shape as the upload
 * request, so uploaded rows round-trip without a second lookup.
 */
export async function getServiceCostPrices(
  service: ServiceIdentifier,
  options?: { signal?: AbortSignal },
): Promise<CostPriceUploadBody> {
  const response: OkResponse<CostPriceUploadBody> = await request(costPricesPath(service), {
    method: 'GET',
    signal: options?.signal,
  });

  return response.result;
}

export async function uploadCostPrices(service: ServiceIdentifier, body: CostPriceUploadBody): Promise<void> {
  await request(costPricesPath(service), {
    method: 'POST',
    headers: json_headers,
    body: JSON.stringify(body),
  });
}
